if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    bindEvents() {
      /* GBOF Essentials CRO mobile sticky v2 */
      this.stickyAddButton = this.querySelector('[data-sticky-atc-add]');
      this.stickyAddButton?.addEventListener('click', this.handleStickyAddToCart.bind(this));
      const nativeSubmit = this.productForm?.querySelector('[name="add"]');
      this.mobileRevealY = nativeSubmit ? nativeSubmit.getBoundingClientRect().top + window.scrollY : 0;
      this.onScroll = () => {
        this.updatePanelVisibility();
        StickyAtcPanel.handleScroll();
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });
      if (this.productInfo) observer.observe(this.productInfo);
      window.addEventListener('scroll', this.onScroll);
      this.updatePanelVisibility();
    }
    updatePanelVisibility() {
      if (!theme.mediaMatches.md) {
        const threshold = Math.max(420, this.mobileRevealY - (window.innerHeight * 0.25));
        this.classList.toggle('sticky-atc-panel--out', window.scrollY < threshold);
      }
    }
    handleStickyAddToCart() {
      const submit = this.productForm?.querySelector('[name="add"]');
      if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
        document.getElementById('variants')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      submit.click();
    }
    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
